export default __webpack_public_path__ + "static/tn-gold-rush-thumbnail-576de4760f534e25e6a4d66bf570dff7.jpg";